import { morphSection } from '@theme/section-renderer';

(() => {
  const removeSelector = '[data-blaze-remove-paired-offer]';

  const getCartUrl = (suffix) => `${window.Theme?.routes?.cart_url || '/cart'}${suffix}`;
  const getCartUpdateUrl = () => window.Theme?.routes?.cart_update_url || '/cart/update.js';

  const getSectionIds = () =>
    Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map((component) => component.dataset.sectionId)
      .filter(Boolean);

  const refreshSections = (sections, wasDrawerOpen) => {
    if (!sections) return window.location.reload();

    Object.entries(sections).forEach(([sectionId, html]) => {
      if (typeof html !== 'string') return;
      const section = document.getElementById(`shopify-section-${sectionId}`);
      if (section) morphSection(sectionId, html, { mode: sectionId === 'cart-drawer-section' ? 'hydration' : 'full' });
    });

    if (wasDrawerOpen) {
      requestAnimationFrame(() => document.querySelector('theme-drawer#cart-drawer')?.open?.());
    }
  };

  const removePairedOffer = async (button) => {
    if (button.dataset.loading === 'true') return;

    button.dataset.loading = 'true';
    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = document.body?.dataset.blazePairedOfferRemoving || 'Removing offer…';

    try {
      const cartResponse = await fetch(getCartUrl('.js'), { credentials: 'same-origin' });
      if (!cartResponse.ok) throw new Error('Unable to load cart');
      const cart = await cartResponse.json();
      const offerType = button.dataset.blazeOfferType || 'buy1_get1';
      const productId = button.dataset.blazeProductId;
      const updates = Object.fromEntries(
        cart.items
          .filter((item) => {
            if (item.properties?._blaze_paired_offer !== 'true') return false;
            if (productId && String(item.product_id) !== String(productId)) return false;
            return (item.properties?._blaze_offer_type || 'buy1_get1') === offerType;
          })
          .map((item) => [item.key, 0])
      );

      if (Object.keys(updates).length === 0) throw new Error('Paired offer was not found in cart');

      const sectionIds = getSectionIds();
      const wasDrawerOpen = document.querySelector('theme-drawer#cart-drawer')?.hasAttribute('open') || false;
      const updateResponse = await fetch(getCartUpdateUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          updates,
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });

      if (!updateResponse.ok) throw new Error('Unable to remove paired offer');
      const updatedCart = await updateResponse.json();
      refreshSections(updatedCart.sections, wasDrawerOpen);
      document.querySelectorAll('cart-icon').forEach((icon) => icon.renderCartBubble?.(updatedCart.item_count, false));
    } catch (error) {
      console.error('[blaze-paired-cart]', error);
      button.disabled = false;
      button.textContent = originalText;
      button.removeAttribute('data-loading');
      window.alert(document.body?.dataset.blazePairedOfferRemoveError || "We couldn't remove the offer. Please try again.");
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest(removeSelector) : null;
    if (button instanceof HTMLButtonElement) removePairedOffer(button);
  });
})();
